import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PendingChangesService } from 'src/app/core/services/app/pending-changes.service';
import { NotificationService } from 'src/app/core/services/app/notification.service';
import { BusinessContextService } from 'src/app/core/services/domain/business-context.service';
import { CustomerService } from 'src/app/core/services/domain/customer.service';
import { BaseEntryPageComponent } from 'src/app/shared/components/base/base-entry-page.component';
import { RoutingService } from 'src/app/core/services/app/routing.service';
import { MessageModel } from 'src/app/shared/models/domain/message.model';
import { MessageService } from 'src/app/core/services/domain/message.service';
import { AuthClientService } from 'src/app/core/services/auth/auth-client.service';

@Component({
  selector: 'app-message-form-dialog',
  templateUrl: './message-form-dialog.component.html'
})
export class MessageFormDialogComponent extends BaseEntryPageComponent<MessageModel> {
  messageHistory: MessageModel[] = null;

  constructor(
    public dialogRef: MatDialogRef<MessageFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: {messageKey: string },
    private businessContextService: BusinessContextService,
    private messageService: MessageService,
    private authClientService: AuthClientService,
    routingService: RoutingService,
    notificationService: NotificationService, pendingChangesService: PendingChangesService) {
    super(notificationService, routingService, pendingChangesService);
  }

  ngOnInit(): void {
    if (this.dialogData?.messageKey) {
      this.messageService.search({messageKey: this.dialogData.messageKey, businessKey: this.businessContextService.currentBusiness.businessKey}).subscribe(message => {
        if (message.length === 1) {
          this.value = message[0];
          this.onRecipientChanged(this.value.recipient.clientKey);

          if (!this.value.recipientReadDateTime && this.authClientService.client.clientKey === this.value.recipient.clientKey) {
            this.messageService.markAsRead(this.value.messageKey).subscribe();
          }
        }
      })
    } else {
      this.value = <MessageModel>{
        business: {
          businessKey: this.businessContextService.currentBusiness.businessKey
        }
      };
    }
  }

  onRecipientChanged($event: string): void {
    if ($event) {
      this.messageService.search({businessKey:  this.businessContextService.currentBusiness.businessKey, recipientClientKey: $event}).subscribe(messages => {
        if (messages.length) {
          if (!this.value.messageKey) {
            messages = [messages[0]];
          }

          if (messages[0].messageKey == this.value.messageKey) {
            messages.shift();
          }

          this.messageHistory = messages;
        } else {
          this.messageHistory = null;
        }
      });
    } else {
      this.messageHistory = null;
    }
  }

  onSaveClicked(): void {
    this.isSaving = true;
    this.messageService.create(this.value).subscribe(key => {
      this.onSaveSuccess('Message was sent successfully.');
      this.dialogRef.close(key);
    }, err => {
      this.onSaveFailed(err);
    });
  }

  onCancelClicked(): void {
    this.dialogRef.close(false);
  }
}
